// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__CrW6k","card":"styles_card__2mL2V","overlay":"styles_overlay__3yXJQ","selected":"styles_selected__1c3ap"};